module.exports = __webpack_public_path__ + "img/c2_competency_catalyst.352bdbac.png";